import React from 'react';
import { motion } from 'framer-motion';

const ScoreCard = ({ label, score, maxScore = 5, color = 'blue' }) => {
  const percentage = (score / maxScore) * 100;
  
  const colorClasses = {
    blue: 'bg-blue-500',
    green: 'bg-green-500',
    orange: 'bg-orange-500',
    purple: 'bg-purple-500',
    indigo: 'bg-indigo-500'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg p-4 shadow-md border border-gray-200"
    >
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium text-gray-700">{label}</h3>
        <span className="text-lg font-bold text-gray-900">{score}/{maxScore}</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className={`h-2 rounded-full ${colorClasses[color]}`}
        />
      </div>
    </motion.div>
  );
};

export default ScoreCard;